<template>
  <div>
    <div
      class="btn-group btn-group-toggle"
      data-toggle=""
      :style="input.disabled || input.readonly ? 'pointer-events: none;' : ''"
    >
      <label
        :for="input.name + index"
        v-for="(item, index) in input.options"
        :class="
          'btn ' +
            (thisValue == item.value || String(thisValue) == String(item.value)
              ? 'active'
              : '')
        "
        v-bind:key="item.value"
      >
        <input
          type="radio"
          :checked="
            thisValue == item.value || String(thisValue) == String(item.value)
          "
          :name="input.name"
          :id="input.name + index"
          autocomplete="off"
          :value="item.value"
          @change="handleChange"
          :readonly="input.readonly"
          :disabled="input.readonly || input.disabled"
        />
        <!-- {{thisValue == item.value}} -->
        <!-- {{thisValue}} O {{item.value}} -->
        {{ item.label }}
      </label>
    </div>
  </div>
</template>
<script>
export default {
  name: "InputRadio",
  components: {},
  props: {
    input: Object,
    value: [String, Boolean, Number],
  },
  data: function() {
    return {
      thisValue: this.value,
    };
  },
  methods: {
    handleChange(e) {
      ////console.log(e);
      this.thisValue = e.target.value;
      ////console.log(this.thisValue + " haha");
      this.$emit("handleChange", e);
    },
    handleChangeClick(e) {
      ////console.log(e);
    },
  },
};
</script>
